// extracted by mini-css-extract-plugin
export default {"label":"styles_label__g8I6Y","altLabel":"styles_altLabel__n+2TW"};